document.addEventListener('DOMContentLoaded', () => {

    const options = {
        valueNames: [ 
            'title',
            'categories',
            'description'
        ],
        // pagination: [{
        //     innerWindow: 2,
        //     outerWindow: 1,
        // }],
        // page: 12
    };
    
    // Create the list!
    const gridList = new List('brandProductTable', options);

    const titleSortToggle = document.getElementById('titleSort');
    const categorySortToggle = document.getElementById('categorySort');

    activeSorts = {
        title: 'asc',
        category: null
    }

    // Initial sort
    gridList.sort('title', { order: "asc" });

    titleSortToggle.addEventListener('click', (e) => {

        if ( ! activeSorts.title || activeSorts.title === 'desc') {
            gridList.sort('title', { order: "asc" });
            activeSorts.title = 'asc';
        } else {
            gridList.sort('title', { order: "desc" });
            activeSorts.title = 'desc';
        }
        
    });

    categorySortToggle.addEventListener('click', (e) => {

        if ( ! activeSorts.category || activeSorts.category === 'desc') {
            gridList.sort('categories', { order: "asc" });
            activeSorts.category = 'asc';
        } else {
            gridList.sort('categories', { order: "desc" });
            activeSorts.category = 'desc';
        }
        
    });

});